import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import ListCdSeller from '../CadastrosCd/ListCdSeller';
import { filialCentroDistribuicaoSeller, filialCentroDistribuicaoSellerComFiltro, gerarExelFilialCentroDistribuicaoSeller } from '../../../../services/http/SellerAdminstradorService/filialCdSellerService'
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';
import { saveAs } from 'file-saver';

import './styles.scss';

const CdSeller = ({ subSellerPage }) => {

    const { idEmpresa } = useParams();
    const { addSnackBar } = useSnackBar();
    const [busca, setBusca] = useState('');
    const [empresaResponse, setEmpresas] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

    const CarregarListaCds = (pagina) => {
        trackPromise(
            filialCentroDistribuicaoSeller(pagina, idEmpresa)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar cds', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar cds', info: 'error', open: true });
        })
    }

    const CarregarListaCdsComFiltro = (filtro, pagina) => {
        trackPromise(
            filialCentroDistribuicaoSellerComFiltro(idEmpresa,filtro, pagina)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar cds', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar cds', info: 'error', open: true });
        })
    }

    const extrairBase = () => {
        trackPromise(
            gerarExelFilialCentroDistribuicaoSeller(idEmpresa)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "cadastros.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base com cds', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base com cds', info: 'error', open: true });
        })
    }

    const mudarPaginaCdSeller = (page) => {
        busca != "" ? CarregarListaCdsComFiltro(busca, page) : CarregarListaCds(page);
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaCdsComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaCds(1);
        }

    }, [busca]);

    useEffect(() => {
        CarregarListaCds(1)
    }, []);

    return (
        <div>

            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Filiais e CDS Cadastrados</h1>
            </div>

            <div className='row'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button onClick={() => subSellerPage('formulario-cd')} className="buton-green btn btn-block btn-lg mt20">
                        CADASTRAR FILIAL / CD
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button className="buton-white-black-border btn btn-block btn-lg mt20" onClick={extrairBase}>
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <ListCdSeller
                subSellerPage={subSellerPage}
                response={empresaResponse}
                mudarPagina={mudarPaginaCdSeller}
                buscar={buscar}
                busca={busca}
            />

        </div>
    );
}

export default CdSeller;